import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getProducts } from "../../services/productApi";
import { getProductImages } from "../../services/imageApi";
import ShopHeader from "./ShopHeader";
import { useCart } from "../../context/CartContext";
import "./productDetails.css";

const ProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [product, setProduct] = useState(null);
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [related, setRelated] = useState([]);
  const [relatedImages, setRelatedImages] = useState({});
  const [zoom, setZoom] = useState(false);

  useEffect(() => {
    loadProduct();
  }, [id]);

  const loadProduct = async () => {
    const products = await getProducts();

    const found = products.find((p) => p.id === Number(id));
    setProduct(found);

    const imgs = await getProductImages(id);
    setImages(imgs);
    setSelectedImage(imgs?.[0]?.image_url);

    const rel = products.filter(
      (p) =>
        p.category_name === found.category_name &&
        p.id !== found.id
    );

    setRelated(rel);

    const map = {};
    for (let p of rel) {
      const i = await getProductImages(p.id);
      map[p.id] = i;
    }
    setRelatedImages(map);
  };

  if (!product) return <p className="loader">Loading...</p>;

  return (
    <div className="shop-page">

      {/* HEADER */}
      <ShopHeader
        categories={[]}
        selectedCategory="All"
        onCategoryClick={() => { }}
      />

      {/* MAIN LAYOUT */}
      <div className="amazon-layout">

        {/* LEFT IMAGE SECTION */}
        <div className="image-section">

          <div
            className="main-image-wrapper"
            onMouseEnter={() => setZoom(true)}
            onMouseLeave={() => setZoom(false)}
          >
            <img
              src={`${selectedImage}`}
              className={`main-image ${zoom ? "zoom" : ""}`}
              alt={product.name}
            />
          </div>

          <div className="thumb-row">
            {images.map((img) => (
              <img
                key={img.id}
                src={`${img.image_url}`}
                className="thumb"
                onClick={() => setSelectedImage(img.image_url)}
                alt=""
              />
            ))}
          </div>
        </div>

        {/* RIGHT BUY BOX */}
        <div className="buy-box">

          <h2>{product.name}</h2>

          <p className="desc">{product.description}</p>

          <div className="price">
            ₹{product.price}
          </div>

          <p className={product.stock_quantity > 0 ? "in" : "out"}>
            {product.stock_quantity > 0 ? "In Stock" : "Out of Stock"}
          </p>

          {/* ✅ FIXED */}
          <button
            className="cart-btn"
            onClick={() => addToCart(product, 1)}
          >
            Add to Cart
          </button>

          <button className="buy-now">
            Buy Now
          </button>

        </div>
      </div>

      {/* RELATED PRODUCTS */}
      <div className="product-grid">

        {related.slice(0, 6).map((p) => (
          <div
            key={p.id}
            className="product-card"
            onClick={() => navigate(`/product/${p.id}`)}
          >
            <img
              src={
                relatedImages[p.id]?.[0]
                  ? `${relatedImages[p.id][0].image_url}`
                  : "https://via.placeholder.com/300"
              }
              className="product-img"
              alt={p.name}
            />

            <div className="product-info">
              <h3>{p.name}</h3>
              <p>₹{p.price}</p>

              {/* ✅ FIXED */}
              <button
                className="cart-btn"
                onClick={() => addToCart(product)}
              >
                Add to Cart
              </button>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default ProductDetails;